import * as $ from 'jquery';
import { OnReadyModule } from '../../lib/app-module';

export interface NavHandlerConfig {
    backgroundToggleClass: string;
    navOpenToggleClass: string;
    openNavSelector: string;
    headerSelector: string;
}

export class NavHandler extends OnReadyModule<NavHandlerConfig> {
    private headerElement: JQuery<HTMLElement>;
    private openNavElement: JQuery<HTMLElement>;
    private documentElement: JQuery<HTMLElement>;
    private backgroundToggleClass: string;

    protected init(): void {
        this.backgroundToggleClass = this.config.backgroundToggleClass;
        this.headerElement = $(this.config.headerSelector);
        this.openNavElement = $(this.config.openNavSelector);
        this.documentElement = $(document.documentElement);
        this.start();
    }

    private start(): void {
        this.monitorScroll();
        this.monitorOpenNav();
        this.toggleHeaderBackground();
    }

    private monitorScroll(): void  {
        $(window).on('scroll', () => this.toggleHeaderBackground());
    }

    private monitorOpenNav(): void {
        this.openNavElement.on('click', (event) => {
            event.preventDefault();
            this.headerElement.toggleClass(this.config.navOpenToggleClass);
            this.toggleHeaderBackground();
        });
    }

    private toggleHeaderBackground(): void {
        const scrollTop = this.documentElement.scrollTop() ?? 0;
        const condition = scrollTop >=  50 || this.headerElement.hasClass(this.config.navOpenToggleClass);
        this.headerElement.toggleClass(this.backgroundToggleClass, condition);
    }
}